import {IPagination} from "../_apiResponse";
import { emptyProvider, Provider } from "../providers/_models";
import { Entity } from "app/models/entity";

export type DriverHoursAbsence = {
    id: number;
    date: string;
    from: string;
    to: string;
    entire_day: false;
    reason: string;
}
export type DriverDaysAbsence = {
    id: number;
    from: string;
    to: string;
    entire_day: true;
    reason: string;
}
export interface DriversPaginated extends IPagination<Driver>{}
export interface Driver extends Entity
{
    name: string;
    surname: string;
    email: string;
    phone: string;
    identity_card: string;
    document: string;
    provider: Provider;
    driverHoursAbsences: Array<any>;
    driverDaysAbsences: Array<any>;
}

export const emptyDriver = {
    id: 0,
    name: "",
    surname: "",
    email: "",
    phone: "",
    identity_card: "",
    document: "",
    provider: emptyProvider,
    driverHoursAbsences: [],
    driverDaysAbsences: [],
}
